<!-- ================ -->
<!--    TEMPLATES     -->
<!-- ================ -->
<!-- ***** COMMON ***** -->
<!-- Inventory Details -->
<ng-template #inventoryDetails>
  <ion-row
    data-cy="create-inventory-page-title-row"
    class="create-inventory-row"
  >
    <ion-col data-cy="create-inventory-page-title-column" size="12">
      <p
        data-cy="create-inventory-page-title-text"
        class="create-inventory-details-text"
      >
        {{ 'i18n.inventory.createInventoryDetails' | translate }}
      </p>
    </ion-col>
  </ion-row>
  <ion-row
    *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
    data-cy="copy-inventory-page-title-row"
    class="copy-inventory-row"
  >
    <ion-col data-cy="copy-inventory-page-title-column" size="12">
      <p
        data-cy="copy-inventory-page-title-text"
        class="copy-inventory-details-text1"
      >
        {{ 'i18n.inventory.copyInventoryDetails1' | translate }}
        <span class="copy-inventory-name"
          >{{(createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value?.inventoryName)
          + ' ' +
          (createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value?.inventoryDate
          | date: 'MM/dd/yy')}}.</span
        >
      </p>
      <p class="copy-inventory-details-text2">
        {{ 'i18n.inventory.copyInventoryDetails2' | translate }}
      </p>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Inventory Name -->
<ng-template
  #inventoryName
  let-form="form"
  let-validationErrors="validationErrors"
>
  <ion-row
    data-cy="create-inventory-name-row"
    [class.create-inventory-row]="platformService?.platformType === platformService?.platformEnum?.mobile"
    [formGroup]="form"
  >
    <ion-col
      data-cy="create-inventory-name-column"
      class="create-inventory-action-column"
      size="12"
    >
      <ion-card-title data-cy="create-inventory-name-label" for="name">
        {{ 'i18n.inventory.createInventoryName' | translate }}
        <span data-cy="create-inventory-required-name-indicator-text">
          {{ 'i18n.common.requiredInputIndicator' | translate }}
        </span>
      </ion-card-title>
      <ion-item
        data-cy="create-inventory-name-section"
        [class.error-state]="validationErrors.nameDateInvalid"
      >
        <ion-textarea
          data-cy="create-inventory-name-input"
          formControlName="name"
          autoGrow="true"
          maxlength="30"
          placeholder="{{ 'i18n.inventory.createInventoryNameInput' | translate }}"
          required="true"
          rows="1"
          (ionInput)="handleNameChange($event)"
        ></ion-textarea>
      </ion-item>
      <p
        *ngIf="validationErrors.nameDateInvalid"
        class="error-message"
        data-cy="create-inventory-name-exists-text"
      >
        {{ 'i18n.inventory.inventoryNameDateError' | translate }}
      </p>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Inventory Date -->
<ng-template #inventoryDate let-validationErrors="validationErrors">
  <ion-row
    data-cy="create-inventory-date-row"
    [class.create-inventory-row]="platformService?.platformType === platformService?.platformEnum?.mobile"
  >
    <ion-col
      data-cy="create-inventory-date-column"
      class="create-inventory-action-column"
      size="12"
    >
      <ion-card-title data-cy="create-inventory-date-label" for="date">
        {{ 'i18n.inventory.createInventoryDate' | translate }}
        <span data-cy="create-inventory-required-date-indicator-text">
          {{ 'i18n.common.requiredInputIndicator' | translate }}
        </span>
      </ion-card-title>
      <ion-item
        data-cy="create-inventory-select-date-section"
        (click)="openCalendarModal()"
        [class.error-state]="validationErrors.nameDateInvalid"
      >
        <ion-label data-cy="create-inventory-date-input">
          {{ createInventoryService?.createInventoryForm?.controls?.date?.value
          | date: "M/d/yyyy" }}
        </ion-label>
      </ion-item>
      <p
        *ngIf="validationErrors.nameDateInvalid"
        class="error-message"
        data-cy="create-inventory-date-exists-text"
      >
        {{ 'i18n.inventory.inventoryNameDateError' | translate }}
      </p>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Populate Inventory -->
<ng-template #populateInventory>
  <ion-card-title data-cy="create-inventory-populate-label">
    {{ 'i18n.inventory.createInventoryPopulate' | translate }}
    <span data-cy="create-inventory-required-populate-indicator-text">
      {{ 'i18n.common.requiredInputIndicator' | translate }}
    </span>
  </ion-card-title>
  <ion-item
    data-cy="create-inventory-populate-section"
    [class.placeholder]="createInventoryService?.createInventoryForm?.controls?.creationType?.invalid"
    detail="true"
    type="button"
    (click)="openPopulateInventoryModal()"
  >
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.creationType?.invalid"
      data-cy="create-inventory-populate-placeholder-text"
    >
      {{ ('i18n.inventory.createInventoryPopulateInput' | translate)}}
    </ion-label>
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
      data-cy="create-inventory-populate-past-inventory-text"
    >
      {{ ('i18n.inventory.fromPastInventory' | translate) }} {{ ' - ' }} {{
      createInventoryService.createInventoryForm.controls.selectedInventory.value.inventoryName
      }} {{
      createInventoryService.createInventoryForm.controls.selectedInventory.value.inventoryDate
      | date: "M/d/yyyy" }}
    </ion-label>
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedShoppingList?.value"
      data-cy="create-inventory-populate-shopping-list-text"
    >
      {{ ('i18n.inventory.fromShoppingLists' | translate) }} {{ ' - ' }} {{
      createInventoryService.createInventoryForm.controls.selectedShoppingList.value.listName
      }}
    </ion-label>
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.pastPurchaseDays?.value"
      data-cy="create-inventory-populate-input-text"
    >
      {{ ('i18n.inventory.populateFromPastPurchases' | translate : {
      pastPurchaseDays:
      createInventoryService.createInventoryForm.controls.pastPurchaseDays.value
      }) }}
    </ion-label>
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.creationType?.value?.code === createInventoryService?.createInventoryModal.manual.valueOf()"
      data-cy="create-inventory-populate-input-text"
    >
      {{ 'i18n.inventory.populateManually' | translate }}
    </ion-label>
    <ion-label
      *ngIf="!createInventoryService?.createInventoryForm"
      data-cy="create-inventory-populate-input-text-placeholder"
    >
      {{ 'i18n.inventory.createInventoryPopulateInput' | translate }}
    </ion-label>
  </ion-item>
</ng-template>

<!-- Select Products -->
<ng-template #selectProducts>
  <ion-card-title data-cy="create-inventory-select-products-label">
    {{ 'i18n.inventory.selectProducts' | translate }}
    <span data-cy="create-inventory-required-select-products-indicator-text">
      {{ 'i18n.common.requiredInputIndicator' | translate }}
    </span>
  </ion-card-title>
  <ion-item
    data-cy="create-inventory-select-products-section"
    detail="true"
    (click)="openSelectedProductsModal()"
  >
    <ion-label
      *ngIf="createInventoryService?.createInventoryForm?.controls?.numberOfSelectedProducts?.value === null; else numSelectedProducts"
      data-cy="create-inventory-select-products-input"
      class="create-inventory-select-products-input"
    >
      {{ 'i18n.inventory.createInventorySelectProducts' | translate }}
    </ion-label>
    <ng-template #numSelectedProducts>
      <ion-label data-cy="create-inventory-select-products-input">
        {{
        createInventoryService.createInventoryForm.controls.numberOfSelectedProducts.value
        }}&nbsp;{{
        createInventoryService.createInventoryForm.controls.numberOfSelectedProducts.value
        === 1 ? 'Product' : 'Products'}}&nbsp;Selected
      </ion-label>
    </ng-template>
  </ion-item>
</ng-template>

<!-- Reset Counts for copy inventory -->
<ng-template #resetCounts>
  <ion-card-title data-cy="create-inventory-select-products-label">
    {{ 'i18n.inventory.resetCountsTitle' | translate }}
  </ion-card-title>
  <ion-radio-group
    [class]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 'radio-options-touch' : 'radio-options'"
    (ionChange)="changeResetCounts()"
    value="reset"
  >
    <ion-item class="no-border-item">
      <ion-label id="reset-counts" data-cy="reset-counts-label">
        {{ 'i18n.inventory.resetCounts' | translate }}
      </ion-label>
      <ion-radio
        aria-labelledby="reset-counts"
        mode="md"
        slot="start"
        value="reset"
      ></ion-radio>
    </ion-item>
    <ion-item class="no-border-item">
      <ion-label id="keep-counts" data-cy="keep-counts-label">
        {{ 'i18n.inventory.keepCounts' | translate }}
      </ion-label>
      <ion-radio
        aria-labelledby="keep-counts"
        mode="md"
        slot="start"
        value="noReset"
        data-cy="reset-counts-radio"
      ></ion-radio>
    </ion-item>
  </ion-radio-group>
</ng-template>

<!-- Fill -->
<ng-template #fill>
  <ion-row
    data-cy="create-inventory-fill-row"
    class="create-inventory-fill-row"
  >
    <ion-col data-cy="create-inventory-fill-column" size="12"></ion-col>
  </ion-row>
</ng-template>

<!-- Submit -->
<ng-template #submit>
  <ion-row data-cy="create-inventory-submit-row">
    <ion-col data-cy="create-inventory-submit-column" size="12">
      <div
        data-cy="create-inventory-subnut-button-section"
        class="create-inventory-submit-section"
      >
        <ion-button
          data-cy="create-inventory-submit-button"
          [ngClass]="createInventoryService?.createInventoryForm?.invalid
            ? 'usf-fill-disabled-dsktp-tblt-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'"
          (click)="onClickSubmit()"
        >
          {{ 'i18n.common.submit' | translate}}
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</ng-template>

<!-- ***** DESKTOP/TABLET ***** -->
<ng-template #formDesktopTablet let-validationErrors="validationErrors">
  <form [formGroup]="createInventoryService.createInventoryForm">
    <ng-container [ngTemplateOutlet]="inventoryDetails"></ng-container>
    <ion-row
      data-cy="create-inventory-actions-row"
      class="create-inventory-row"
    >
      <!-- Left Column -->
      <ion-col data-cy="create-inventory-left-actions-column" size="5.625">
        <ng-container
          *ngTemplateOutlet="inventoryName; context: { form: createInventoryService.createInventoryForm, validationErrors:validationErrors}"
        ></ng-container>
        <ion-row data-cy="create-inventory-populate-row">
          <ion-col
            data-cy="create-inventory-populate-column"
            class="create-inventory-action-column create-inventory-bottom-action-column"
            size="12"
          >
            <ng-container [ngTemplateOutlet]="populateInventory"></ng-container>
          </ion-col>
        </ion-row>
      </ion-col>
      <!-- Right Column -->
      <ion-col
        data-cy="create-inventory-right-actions-column"
        size="5.625"
        offset="0.75"
      >
        <ng-container
          [ngTemplateOutlet]="inventoryDate"
          [ngTemplateOutletContext]="{validationErrors:validationErrors}"
        ></ng-container>
        <ion-row
          *ngIf="createInventoryService?.createInventoryForm?.controls?.pastPurchaseDays?.value"
          data-cy="create-inventory-select-products-row"
        >
          <ion-col
            data-cy="create-inventory-select-products-column"
            class="create-inventory-action-column create-inventory-bottom-action-column"
            size="12"
          >
            <ng-container [ngTemplateOutlet]="selectProducts"></ng-container>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
          data-cy="create-inventory-reset-counts-row"
        >
          <ion-col
            data-cy="create-inventory-reset-counts-column"
            class="create-inventory-action-column create-inventory-bottom-action-column"
            size="12"
          >
            <ng-container [ngTemplateOutlet]="resetCounts"></ng-container>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-card-title
      class="selected-inventory-title"
      data-cy="create-inventory-populate-label"
      *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
    >
      {{ 'i18n.inventory.selectedInventory' | translate }}
    </ion-card-title>
    <ng-container
      [ngTemplateOutlet]="selectedInventoryDesktopTablet"
    ></ng-container>
    <ng-container [ngTemplateOutlet]="fill"></ng-container>
    <ng-container [ngTemplateOutlet]="submit"></ng-container>
  </form>
</ng-template>

<!-- ***** MOBILE ***** -->
<ng-template #formMobile let-validationErrors="validationErrors">
  <form [formGroup]="createInventoryService.createInventoryForm">
    <ng-container [ngTemplateOutlet]="inventoryDetails"></ng-container>
    <ng-container
      *ngTemplateOutlet="inventoryName; context: { form: createInventoryService.createInventoryForm, validationErrors:validationErrors}"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="inventoryDate"
      [ngTemplateOutletContext]="{validationErrors:validationErrors}"
    ></ng-container>
    <ion-row
      data-cy="create-inventory-populate-row"
      class="create-inventory-row"
    >
      <ion-col
        data-cy="create-inventory-populate-column"
        class="create-inventory-action-column"
        size="12"
      >
        <ng-container [ngTemplateOutlet]="populateInventory"></ng-container>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="createInventoryService?.createInventoryForm?.controls?.pastPurchaseDays?.value"
      data-cy="create-inventory-select-products-row"
      class="create-inventory-row"
    >
      <ion-col
        data-cy="create-inventory-select-products-column"
        class="create-inventory-action-column"
        size="12"
      >
        <ng-container [ngTemplateOutlet]="selectProducts"></ng-container>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
      class="reset-counts-row"
      data-cy="create-inventory-reset-counts-row"
    >
      <ion-col
        data-cy="create-inventory-reset-counts-column"
        class="create-inventory-action-column create-inventory-bottom-action-column"
        size="12"
      >
        <ng-container [ngTemplateOutlet]="resetCounts"></ng-container>
      </ion-col>
    </ion-row>
    <ion-card-title
      class="selected-inventory-title"
      data-cy="create-inventory-populate-label"
      *ngIf="createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value"
    >
      {{ 'i18n.inventory.selectedInventory' | translate }}
    </ion-card-title>
    <ng-container [ngTemplateOutlet]="selectedInventoryMobile"></ng-container>
    <ng-container [ngTemplateOutlet]="fill"></ng-container>
    <ng-container [ngTemplateOutlet]="submit"></ng-container>
  </form>
</ng-template>

<!-- Selected Inventory Desktop -->
<ng-template #selectedInventoryDesktopTablet>
  <ion-row
    data-cy="inventory-data-row"
    class="selected-inventory-row ion-justify-content-between"
    *ngIf="(selectedInventory$ | async) as selectedInventory"
  >
    <!-- Inventory Name: Non-completed card variation: -->
    <ion-col
      data-cy="inventory-data-name-column"
      class="inventory-name-col"
      size="3.5"
      offset="0.25"
      *ngIf="selectedInventory.status !== InventoryStatus.COMPLETED"
    >
      <p data-cy="inventory-data-name-text">
        {{ selectedInventory?.inventoryName }} - {{
        selectedInventory?.inventoryDate | date: 'M/d/yyyy' }}
      </p>
      <p
        data-cy="inventory-data-updated"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        {{ 'i18n.common.lastUpdatedBy' | translate }} {{ !(
        selectedInventory?.updatedByUser?.firstName ||
        selectedInventory?.updatedByUser?.lastName ) ? ('i18n.common.system' |
        translate) + ', ' : selectedInventory?.updatedByUser?.firstName !==
        selectedInventory?.updatedByUser?.lastName ?
        selectedInventory?.updatedByUser?.firstName + ' ' +
        selectedInventory?.updatedByUser?.lastName + ', ' :
        selectedInventory?.updatedByUser?.firstName + ', ' }}
      </p>
      <p
        data-cy="inventory-data-last-updated-date-text"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        {{ 'i18n.inventory.lastUpdatedDateInfo' | translate : { userId:
        selectedInventory?.updatedByUser?.userName || 'NO DATA', updateDate:
        (selectedInventory?.ecomUpdateDtm | date: 'M/d/yyyy') || 'NO DATA' } }}
      </p>
    </ion-col>

    <!-- Inventory Name: Completed card variation -->

    <ion-col
      class="completed"
      size=".3"
      offset="0"
      *ngIf="selectedInventory.status === InventoryStatus.COMPLETED"
    >
      <div class="completed-text">
        {{ 'i18n.inventory.complete' | translate }}
      </div>
    </ion-col>

    <ion-col
      data-cy="inventory-data-name-column"
      class="inventory-name-col"
      size="3.5"
      offset="0.05"
      *ngIf="selectedInventory.status === InventoryStatus.COMPLETED"
    >
      <p data-cy="inventory-data-name-text">
        {{ selectedInventory?.inventoryName }} - {{
        selectedInventory?.inventoryDate | date: 'M/d/yyyy' }}
      </p>
      <p
        data-cy="inventory-data-updated"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        {{ 'i18n.common.lastUpdatedBy' | translate }} {{ !(
        selectedInventory?.updatedByUser?.firstName ||
        selectedInventory?.updatedByUser?.lastName ) ? ('i18n.common.system' |
        translate) + ', ' : selectedInventory?.updatedByUser?.firstName !==
        selectedInventory?.updatedByUser?.lastName ?
        selectedInventory?.updatedByUser?.firstName + ' ' +
        selectedInventory?.updatedByUser?.lastName + ', ' :
        selectedInventory?.updatedByUser?.firstName + ', ' }}
      </p>
      <p
        data-cy="inventory-data-last-updated-date-text"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
      >
        {{ 'i18n.inventory.lastUpdatedDateInfo' | translate : { userId:
        selectedInventory?.updatedByUser?.userName || 'NO DATA', updateDate:
        (selectedInventory?.ecomUpdateDtm | date: 'M/d/yyyy') || 'NO DATA' } }}
      </p>
    </ion-col>

    <!-- Last Updated -->
    <ion-col
      data-cy="inventory-data-last-updated-column"
      class="inventory-data-last-updated-col"
      [size]="platformService?.platformType === platformService?.platformEnum?.tablet ? 2 : 2.5"
      offset="0.15"
    >
      <!-- First Name, Last Name OR System -->
      <p
        data-cy="inventory-data-updated"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
      >
        {{ 'i18n.common.lastUpdatedBy' | translate }} {{ !(
        selectedInventory?.updatedByUser?.firstName ||
        selectedInventory?.updatedByUser?.lastName ) ? ('i18n.common.system' |
        translate) + ', ' : selectedInventory?.updatedByUser?.firstName !==
        selectedInventory?.updatedByUser?.lastName ?
        selectedInventory?.updatedByUser?.firstName + ' ' +
        selectedInventory?.updatedByUser?.lastName + ', ' :
        selectedInventory?.updatedByUser?.firstName + ', ' }}
      </p>
      <!-- Updated date -->
      <p
        data-cy="inventory-data-last-updated-date-text"
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
      >
        {{ 'i18n.inventory.lastUpdatedDateInfo' | translate : { userId:
        selectedInventory?.updatedByUser?.userName || 'NO DATA', updateDate:
        (selectedInventory?.ecomUpdateDtm | date: 'M/d/yyyy') || 'NO DATA' } }}
      </p>
    </ion-col>
    <!-- Created -->
    <ion-col
      data-cy="inventory-data-created-column"
      class="inventory-data-created-col"
      size="2.5"
      offset="0.15"
    >
      <!-- First Name, Last Name OR System -->
      <p data-cy="inventory-data-created-by">
        {{ 'i18n.inventory.createdBy' | translate }} {{ !(
        selectedInventory?.createdByUser?.firstName ||
        selectedInventory?.createdByUser?.lastName ) ? ('i18n.common.system' |
        translate) + ', ' : selectedInventory?.createdByUser?.firstName !==
        selectedInventory?.createdByUser?.lastName ?
        selectedInventory?.createdByUser?.firstName + ' ' +
        selectedInventory?.createdByUser?.lastName + ', ' :
        selectedInventory?.createdByUser?.firstName + ', ' }}
      </p>
      <!-- Created Date -->
      <p data-cy="inventory-data-created-date-text">
        {{ 'i18n.inventory.lastUpdatedDateInfo' | translate : { userId:
        selectedInventory?.createdByUser?.userName || 'NO DATA', updateDate:
        (selectedInventory?.ecomCreatedDtm | date: 'M/d/yyyy') || 'NO DATA' } }}
      </p>
    </ion-col>
    <!-- Products -->
    <ion-col data-cy="inventory-data-products-column" size="1">
      <div data-cy="inventory-data-products-section" class="green-badge">
        <ion-badge data-cy="inventory-data-products-icon" mode="ios">
          {{ selectedInventory?.numProductsByQuantities }}
        </ion-badge>
      </div>
    </ion-col>
    <!-- Value -->
    <ion-col
      data-cy="inventory-data-value-column"
      class="inventory-data-value-col"
      [size]="platformService?.platformType === platformService?.platformEnum?.tablet ? 1.5 : 1"
      offset="0.25"
    >
      <p data-cy="inventory-data-value-text">
        {{ (selectedInventory?.totalPrice ? selectedInventory?.totalPrice :
        '0.00') | currency }}
      </p>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #selectedInventoryMobile>
  <ion-row
    data-cy="inventory-data-row"
    *ngIf="(selectedInventory$ | async) as selectedInventory"
    class="selected-inventory-row"
  >
    <ion-col data-cy="inventory-data-column" size="12">
      <ion-card data-cy="inventory-data-card" class="inventory-data-card">
        <!-- Completed Banner, or nbsp: -->
        <div
          class="completed-banner-container"
          *ngIf="selectedInventory?.status === InventoryStatus.COMPLETED"
        >
          <p class="completed-text">
            {{ 'i18n.inventory.complete' | translate }}
          </p>
        </div>

        <div
          class="completed-banner-container-empty"
          *ngIf="selectedInventory?.status !== InventoryStatus.COMPLETED"
        >
          <p>&nbsp;</p>
        </div>

        <div class="card-contents-container">
          <!-- Name, User Date, Created Date, Ellipsis -->
          <ion-item
            data-cy="inventory-data-card-top-section"
            class="inventory-data-card-top"
          >
            <ion-col
              data-cy="inventory-data-card-name-created-column"
              size="11"
            >
              <!-- Name, User Date -->
              <p data-cy="inventory-data-card-name-text">
                {{ selectedInventory?.inventoryName }} - {{
                selectedInventory?.inventoryDate | date: 'M/d/yyyy' }}
              </p>
              <!-- Created Date -->
              <p class="name-date" data-cy="inventory-data-created-by">
                {{ 'i18n.inventory.createdBy' | translate }} {{ !(
                selectedInventory?.createdByUser?.firstName ||
                selectedInventory?.createdByUser?.lastName ) ?
                ('i18n.common.system' | translate) + ', ' :
                selectedInventory?.createdByUser?.firstName !==
                selectedInventory?.createdByUser?.lastName ?
                selectedInventory?.createdByUser?.firstName + ' ' +
                selectedInventory?.createdByUser?.lastName + ', ' +
                selectedInventory?.createdByUser?.userName + ' on' :
                selectedInventory?.createdByUser?.firstName + ', ' +
                selectedInventory?.createdByUser?.userName + ' on' }}
              </p>
              <p class="name-date" data-cy="inventory-data-card-created-text">
                {{ (selectedInventory?.ecomCreatedDtm | date: 'M/d/yyyy') || 'NO
                DATA' }}
              </p>
            </ion-col>
          </ion-item>

          <!-- Last Updated, Products, Value -->
          <ion-item
            data-cy="inventory-data-card-bottom-section"
            class="inventory-data-card-bottom"
            lines="none"
          >
            <!-- Last Updated -->
            <ion-col data-cy="inventory-data-last-updated-column" size="6">
              <!-- Last Updated By -->
              <p
                data-cy="inventory-data-last-updated-name-text"
                class="last-updated-text"
              >
                {{ 'i18n.common.lastUpdatedBy' | translate }} {{ !(
                selectedInventory?.updatedByUser?.firstName ||
                selectedInventory?.updatedByUser?.lastName ) ?
                ('i18n.common.system' | translate) + ', ' :
                selectedInventory?.updatedByUser?.firstName !==
                selectedInventory?.updatedByUser?.lastName ?
                selectedInventory?.updatedByUser?.firstName + ' ' +
                selectedInventory?.updatedByUser?.lastName + ', ' :
                selectedInventory?.updatedByUser?.firstName + ', ' }}
              </p>
              <p
                data-cy="
                  inventory-data-last-updated-username-date-text
                "
                class="last-updated-text"
              >
                {{ 'i18n.inventory.lastUpdatedDateInfo' | translate : { userId:
                selectedInventory?.updatedByUser?.userName || 'NO DATA',
                updateDate: (selectedInventory?.ecomUpdateDtm | date:
                'M/d/yyyy') || 'NO DATA' } }}
              </p>
            </ion-col>
            <!-- Products -->
            <ion-col
              data-cy="inventory-data-products-column"
              size="2.5"
              offset="0.5"
            >
              <div
                data-cy="inventory-data-products-section"
                class="green-badge"
              >
                <ion-badge
                  data-cy="'inventory-data-products-icon-' + i"
                  mode="ios"
                >
                  {{ selectedInventory?.numProductsByQuantities }}
                </ion-badge>
              </div>
            </ion-col>
            <!-- Value -->
            <ion-col
              data-cy="list-data-discontinued-column"
              size="2.75"
              offset="0.25"
            >
              <p data-cy="'inventory-data-value-text-' + i">
                {{ (selectedInventory?.totalPrice ?
                selectedInventory?.totalPrice : '0.00') | currency }}
              </p>
            </ion-col>
          </ion-item>
        </div>
      </ion-card>
    </ion-col>
  </ion-row>
</ng-template>

<!-- ================ -->
<!--   PAGE CONTENT   -->
<!-- ================ -->
<app-header></app-header>

<ion-content
  id="create-inventory_content"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
  *ngIf="validationErrors$ | async as validationErrors"
>
  <!-- Header (Desktop) -->
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    data-cy="create-inventory-header-section"
    class="create-inventory-header"
  >
    <ion-grid data-cy="create-inventory-header-grid" [fixed]="true">
      <!-- Breadcrumbs -->
      <ion-row data-cy="create-inventory-breadcrumbs-row">
        <ion-col data-cy="create-inventory-breadcrumbs-column" size="12">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>
      <!-- Title -->
      <ion-row data-cy="create-inventory-title-row">
        <ion-col data-cy="create-inventory-title-column" size="12">
          <h2 data-cy="create-inventory-title-text">
            {{
            createInventoryService?.createInventoryForm?.controls?.selectedInventory?.value
            ? ('i18n.inventory.copyInventoryTitle' | translate) :
            ('i18n.inventory.createInventoryTitle' | translate) }}
          </h2>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- Page Content -->
  <ion-grid data-cy="create-inventory-content-grid" [fixed]="true">
    <ion-card data-cy="create-inventory-card">
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop || platformService?.platformType === platformService?.platformEnum?.tablet"
        [ngTemplateOutlet]="formDesktopTablet"
        [ngTemplateOutletContext]="{validationErrors:validationErrors}"
      ></ng-container>
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
        [ngTemplateOutlet]="formMobile"
        [ngTemplateOutletContext]="{validationErrors:validationErrors}"
      ></ng-container>
    </ion-card>
  </ion-grid>

  <!-- Footer (Desktop) -->
  <app-footer></app-footer>
</ion-content>

<!-- Select Product Modal -->
<ion-modal
  [isOpen]="selectedProductsModalIsOpen$ | async"
  (ionModalWillPresent)="createInventoryService.searchRecentPurchase('')"
  (ionModalDidDismiss)="handleSelectedProductsModalDismiss($event)"
  [class]="
    platformService?.platformType === platformService?.platformEnum?.mobile
      ? 'ion-modal-touch'
      : 'create-inventory-select-products-modal'
  "
  id="addToInventoryModal"
  [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
>
  <ng-template>
    <app-add-to-inventory
      [viewModel$]="addToInventoryViewModel$"
      (selectProductEmitter)="selectProduct($event)"
      (selectAllProductsEmitter)="selectAllProducts($event)"
      (searchEmitter)="createInventoryService.searchRecentPurchase($event)"
      (selectMultipleProductsEmitter)="selectMultipleProducts($event)"
    ></app-add-to-inventory>
  </ng-template>
</ion-modal>
